import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import socketIOClient from 'socket.io-client'

import { makeRequest } from '../../core/services/v1/request'
import Config from '../../core/config/'
import './MarketPage.css'

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { styled } from '@mui/system'
import { useContextData } from '../../core/context'
import LoaderUnitic from '../../Component/Loader/LoaderUnitic'
import { Button } from '@mui/material'
import { showPairNameUsdt } from '../../core/helper/date-format'

const StyledTableHeadRow = styled(TableCell)(() => ({
  borderBottom: 'none',
  fontFamily:
    'Roboto, "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei"',
  fontSize: '14px',
  fontWeight: '500',
  fontStyle: 'normal',
  padding: '5px',
  paddingBottom: '16px',
  width: 'auto !important',
  color: 'white',
  textAlign: 'left',
}))

const StyledTableCell = styled(TableCell)(() => ({
  borderBottom: 'none',
  fontFamily:
    'Roboto, "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei"',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '27px',
  padding: '5px',
  width: 'auto !important',
  color: 'white',
  textAlign: 'left',
}))

const StyledTableCellFirst = styled(TableCell)(() => ({
  borderBottom: 'none',
  fontFamily:
    'Roboto, "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei"',
  fontStyle: 'normal',
  fontWeight: '600',
  fontSize: '14px',
  lineHeight: '27px',
  padding: '5px',
  color: 'white',
  width: '230px !important',
}))

const StyledTableHead = styled(TableHead)(() => ({
  borderBottom: 'none',
  fontFamily:
    'Roboto, "PingFang SC", -apple-system, BlinkMacSystemFont, "Microsoft YaHei"',
  fontSize: '32px',
  fontWeight: '600',
  padding: '5px',
  fontStyle: 'normal',
  lineHeight: '38px',
  width: 'auto !important',
  color: 'white',
  textAlign: 'left',
}))

const DEFAULT_USDT_LIMIT = 25

const USDT_LIMIT_OPTIONS = [
  5,
  10,
  25,
  50,
  100,
]

const UTI = ({ marketCurrency, search, isKucoin = false }) => {
  const navigate = useNavigate()
  const { coindcxDecimal } = useContextData()

  const [markets, setMarkets] = useState([])
  const [topMarkets, setTopMarkets] = useState([])
  const [socketConnection, setSocketConnection] = useState(null)

  const [loader, setLoader] = useState(false)
  const [usdtPage, setUsdtPage] =
    useState(1)

  const [usdtLimit, setUsdtLimit] =
    useState(DEFAULT_USDT_LIMIT)

  const [usdtPagination, setUsdtPagination] =
    useState({
      page: 1,
      limit: DEFAULT_USDT_LIMIT,

      total: 0,
      totalPages: 0,

      hasNextPage: false,
      hasPreviousPage: false,

      nextPage: null,
      previousPage: null,
    })
  useEffect(() => {
    if (marketCurrency === 'USDT') {
      setUsdtPage(1)
    }
  }, [search, marketCurrency])

  useEffect(() => {
    getMarkets()
  }, [search, marketCurrency, usdtPage, usdtLimit])
  useEffect(() => {
    const socket = socketIOClient(Config.SOCKET_URL, {
      transports: ['websocket'],
    })

    let socketUnsubscribe

    getTopMarkets()

    if (socket) {
      socket.on('connect', () => {
        setSocketConnection(socket)
        socketUnsubscribe = socket
      })

      socket.on('connect_error', (err) => {
        console.log('socket connect_error', err)
      })

      socket.on('disconnect', () => {
        // console.log('socket disconnected')
      })
    }

    return () => {
      if (socketUnsubscribe) {
        socketUnsubscribe.disconnect()
      }
    }
  }, [])

  const handleLimitChange = (event) => {
    const newLimit =
      Number(event.target.value)

    setUsdtLimit(newLimit)

    setUsdtPage(1)
  }
  function formatNumber(num = 0) {
    num = Number(num)

    if (num === 0) {
      return 0
    }

    const suffixes = ['', 'K', 'M', 'B', 'T']
    const factor = 1000

    let suffixIndex = 0
    let formattedNumber = num

    while (
      formattedNumber >= factor &&
      suffixIndex < suffixes.length - 1
    ) {
      formattedNumber /= factor
      suffixIndex++
    }

    return `${formattedNumber.toFixed(2)}${suffixes[suffixIndex]}`
  }

  useEffect(() => {
    if (socketConnection == null) {
      return
    }

    const handlePairResponse = (data) => {
      if (marketCurrency === 'USDT') {
        return
      }

      setMarkets((previousMarkets) => {
        return previousMarkets.map((market) => {
          if (data.pair !== market.pair) {
            return market
          }

          const newPrice = Number(data.price).toFixed(
            data.decimalValue,
          )

          const oldPrice = Number(
            market.price,
          ).toFixed(
            market.decimalValue,
          )

          if (newPrice === oldPrice) {
            return market
          }

          return {
            ...market,
            price: data.price,
            lastPrice: data.lastPrice,
            change: data.change,
            oldPrice: market.price,
          }
        })
      })
    }

    socketConnection.on(
      'pairResponse',
      handlePairResponse,
    )

    return () => {
      socketConnection.off(
        'pairResponse',
        handlePairResponse,
      )
    }
  }, [
    socketConnection,
    marketCurrency,
  ])
  useEffect(() => {
    if (socketConnection == null) {
      return
    }

    getTopMarkets()

    const handlePairResponse = (data) => {
      setTopMarkets((previousMarkets) => {
        return previousMarkets.map((market) => {
          if (data.pair !== market.pair) {
            return market
          }

          const newPrice = Number(data.price).toFixed(
            data.decimalValue,
          )

          const oldPrice = Number(
            market.price,
          ).toFixed(
            market.decimalValue,
          )

          if (newPrice === oldPrice) {
            return market
          }

          return {
            ...market,
            price: data.price,
            lastPrice: data.lastPrice,
            change: data.change,
            oldPrice: market.price,
          }
        })
      })
    }

    socketConnection.on(
      'pairResponse',
      handlePairResponse,
    )

    return () => {
      socketConnection.off(
        'pairResponse',
        handlePairResponse,
      )
    }
  }, [socketConnection])

  async function getMarkets() {
    try {
      setLoader(true)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      if (marketCurrency !== 'USDT') {
        const params = {
          url: `${Config.V1_API_URL}trade/getMarkets`,
          method: 'GET',
        }

        const response = await makeRequest(params)

        if (response.status) {
          const normalizedSearch = (
            search || ''
          ).toLowerCase()

          const filterData = (
            response?.data || []
          ).filter(
            (data) =>
              data?.pair?.includes(
                marketCurrency,
              ) &&
              data?.pair
                ?.toLowerCase()
                .includes(
                  normalizedSearch,
                ),
          )

          if (
            normalizedSearch === 'unitic'
          ) {
            setMarkets([])
          } else {
            setMarkets(filterData)
          }
        }

        return
      }

      const query =
        new URLSearchParams({
          search: search || '',
          page: String(usdtPage),
          limit: String(usdtLimit),
        })

      const params = {
        url:
          `${Config.V3_API_URL}` +
          `trade/getMarketsUSDT?` +
          query.toString(),

        method: 'GET',
      }

      const response =
        await makeRequest(params)

      if (response.status) {
        setMarkets(
          response?.data || [],
        )

        setUsdtPagination(
          response?.pagination || {
            page: usdtPage,
            limit: usdtLimit,

            total: 0,
            totalPages: 0,

            hasNextPage: false,
            hasPreviousPage: false,

            nextPage: null,
            previousPage: null,
          },
        )
      } else {
        setMarkets([])

        setUsdtPagination({
          page: 1,
          limit: usdtLimit,

          total: 0,
          totalPages: 0,

          hasNextPage: false,
          hasPreviousPage: false,

          nextPage: null,
          previousPage: null,
        })
      }
    } catch (err) {
      console.log(
        'getMarkets error:',
        err,
      )

      setMarkets([])
    } finally {
      setLoader(false)
    }
  }
  async function getTopMarkets() {
    try {
      const params = {
        url: `${Config.V1_API_URL}trade/getHomeMarkets`,
        method: 'GET',
      }

      const response =
        await makeRequest(params)

      if (response.status) {
        setTopMarkets(
          response?.data?.topGainers || [],
        )
      }
    } catch (err) {
      console.log(
        'getTopMarkets error:',
        err,
      )
    }
  }

  const getPaginationPages = (
    currentPage,
    totalPages,
  ) => {
    if (totalPages <= 7) {
      return Array.from(
        {
          length: totalPages,
        },
        (_, index) => index + 1,
      )
    }

    const pages = []

    // Always first page
    pages.push(1)

    // Near beginning
    if (currentPage <= 4) {
      pages.push(
        2,
        3,
        4,
        5,
        '...',
        totalPages,
      )

      return pages
    }

    // Near ending
    if (
      currentPage >=
      totalPages - 3
    ) {
      pages.push(
        '...',
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      )

      return pages
    }

    // Middle
    pages.push(
      '...',
      currentPage - 1,
      currentPage,
      currentPage + 1,
      '...',
      totalPages,
    )

    return pages
  }
  const navigateToUsdtTrade = (symbol) => {
    navigate(
      '/spot-usdt/' +
      showPairNameUsdt(
        symbol,
        '-',
      ),
    )
  }

  const hasMarkets =
    Array.isArray(markets) &&
    markets.length > 0

  return (
    <div className='my-2'>
      {!loader && hasMarkets && (
        <>
          <TableContainer>
            <Table
              sx={{
                minWidth:
                  window.innerWidth < 700
                    ? 1000
                    : 100,
                justifyContent:
                  'center',
              }}
              aria-label='simple table'
            >
              <StyledTableHead>
                <TableRow>
                  <StyledTableHeadRow>
                    Pair/Token
                  </StyledTableHeadRow>

                  <StyledTableHeadRow>
                    Last Price
                  </StyledTableHeadRow>

                  <StyledTableHeadRow>
                    24 Change
                  </StyledTableHeadRow>

                  <StyledTableHeadRow>
                    24 High
                  </StyledTableHeadRow>

                  <StyledTableHeadRow>
                    24 Low
                  </StyledTableHeadRow>

                  <StyledTableHeadRow>
                    24 Volume
                  </StyledTableHeadRow>

                  <StyledTableHeadRow>
                    <h3
                      style={{
                        fontSize: '14px',
                      }}
                    >
                      Trade
                    </h3>
                  </StyledTableHeadRow>
                </TableRow>
              </StyledTableHead>

              <TableBody>
                {markets.map(
                  (data, i) => {
                    if (
                      data?.pair ===
                      'UNITIC_INR'
                    ) {
                      return null
                    }

                    const coindcxDecimalSingle =
                      !isKucoin
                        ? coindcxDecimal[
                        data?.pair
                          ?.split('_')
                          .join('')
                        ]
                        : null

                    if (
                      marketCurrency !==
                      'USDT' &&
                      !isKucoin
                    ) {
                      return (
                        <TableRow
                          key={
                            data?.pair || i
                          }
                        >
                          <StyledTableCellFirst
                            component='th'
                            scope='row'
                            onClick={() =>
                              navigate(
                                '/spot/' +
                                data?.pair,
                              )
                            }
                            style={{
                              cursor:
                                'pointer',
                            }}
                          >
                            {data
                              ?.fromCurrency
                              ?.image && (
                                <img
                                  src={
                                    data
                                      .fromCurrency
                                      .image
                                  }
                                  alt={
                                    data
                                      ?.fromCurrency
                                      ?.symbol ||
                                    'logo'
                                  }
                                  className='market-table-data-logo me-2'
                                />
                              )}

                            {data?.pair &&
                              data.pair
                                .split('_')
                                .join(
                                  '/',
                                )}
                          </StyledTableCellFirst>

                          <StyledTableCell
                            className={
                              data.lastPrice >
                                0
                                ? data.lastPrice <
                                  data.price
                                  ? 'blinkGreenColor'
                                  : 'blinkRedColor'
                                : ''
                            }
                          >
                            {Number(
                              data.price,
                            ).toFixed(
                              coindcxDecimalSingle
                                ?.base_currency_precision ||
                              5,
                            )}
                          </StyledTableCell>

                          <StyledTableCell
                            className={
                              data.change >= 0
                                ? 'color-green'
                                : 'color-red'
                            }
                          >
                            {data.change >=
                              0
                              ? '+' +
                              Number(
                                data.change,
                              ).toFixed(
                                2,
                              )
                              : Number(
                                data.change,
                              ).toFixed(
                                2,
                              )}{' '}
                            %
                          </StyledTableCell>

                          <StyledTableCell>
                            {Number(
                              data.high,
                            ).toFixed(
                              coindcxDecimalSingle
                                ?.base_currency_precision ||
                              5,
                            )}
                          </StyledTableCell>

                          <StyledTableCell>
                            {Number(
                              data.low,
                            ).toFixed(
                              coindcxDecimalSingle
                                ?.base_currency_precision ||
                              5,
                            )}
                          </StyledTableCell>

                          <StyledTableCell>
                            {Number(
                              data.volume,
                            ).toFixed(
                              2,
                            )}
                          </StyledTableCell>

                          <StyledTableCell>
                            <Button
                              className='border-0 btn-default'
                              sx={{
                                textTransform:
                                  'none',
                                borderRadius:
                                  '12px',
                                fontWeight: 700,
                              }}
                              onClick={() =>
                                navigate(
                                  '/spot/' +
                                  data.pair,
                                )
                              }
                            >
                              Trade
                            </Button>
                          </StyledTableCell>
                        </TableRow>
                      )
                    }

                    return (
                      <TableRow
                        key={
                          data?.symbol || i
                        }
                      >
                        <StyledTableCellFirst
                          component='th'
                          scope='row'
                          onClick={() =>
                            navigateToUsdtTrade(
                              data?.symbol,
                            )
                          }
                          style={{
                            cursor:
                              'pointer',
                          }}
                        >
                          {(data?.image) && (
                            <img
                              src={
                                data.image
                              }
                              alt={
                                data?.baseCoin ||
                                data?.symbol ||
                                'coin'
                              }
                              className='market-table-data-logo me-2'
                              loading='lazy'
                              onError={(
                                event,
                              ) => {
                                event.currentTarget.style.display =
                                  'none'
                              }}
                            />
                          )}

                          {showPairNameUsdt(
                            data?.symbol,
                          )}
                        </StyledTableCellFirst>

                        <StyledTableCell
                          className={
                            Number(
                              data?.lastPrice,
                            ) > 0
                              ? Number(
                                data?.price24hPcnt ||
                                '0',
                              ) > 0
                                ? 'blinkGreenColor'
                                : 'blinkRedColor'
                              : ''
                          }
                        >
                          {data?.lastPrice}
                        </StyledTableCell>

                        <StyledTableCell
                          className={
                            Number(
                              data?.price24hPcnt,
                            ) *
                              100 >=
                              0
                              ? 'color-green'
                              : 'color-red'
                          }
                        >
                          {Number(
                            data?.price24hPcnt ||
                            '0',
                          ) >= 0
                            ? '+' +
                            (
                              Number(
                                data?.price24hPcnt ||
                                '0',
                              ) * 100
                            ).toFixed(
                              2,
                            )
                            : (
                              Number(
                                data?.price24hPcnt ||
                                '0',
                              ) * 100
                            ).toFixed(
                              2,
                            )}{' '}
                          %
                        </StyledTableCell>

                        <StyledTableCell>
                          {
                            data?.highPrice24h
                          }
                        </StyledTableCell>

                        <StyledTableCell>
                          {
                            data?.lowPrice24h
                          }
                        </StyledTableCell>

                        <StyledTableCell>
                          {formatNumber(
                            Number(
                              data?.turnover24h,
                            ),
                          )}
                        </StyledTableCell>

                        <StyledTableCell>
                          <Button
                            className='border-0 btn-default'
                            sx={{
                              textTransform:
                                'none',
                              borderRadius:
                                '12px',
                              fontWeight: 700,
                            }}
                            onClick={() =>
                              navigateToUsdtTrade(
                                data?.symbol,
                              )
                            }
                          >
                            Trade
                          </Button>
                        </StyledTableCell>
                      </TableRow>
                    )
                  },
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {marketCurrency === 'USDT' &&
            usdtPagination.total > 0 && (
              <div className='market-pagination-wrapper'>

                <div className='market-pagination-info'>
                  Showing{' '}
                  {Math.min(
                    ((usdtPage - 1) * usdtLimit) + 1,
                    usdtPagination.total,
                  )}
                  {' - '}
                  {Math.min(
                    usdtPage * usdtLimit,
                    usdtPagination.total,
                  )}
                  {' of '}
                  {usdtPagination.total}
                </div>

                <div className='market-pagination'>

                  <button
                    type='button'
                    className='market-page-btn'
                    disabled={
                      loader ||
                      !usdtPagination.hasPreviousPage
                    }
                    onClick={() => {
                      if (
                        usdtPagination.previousPage
                      ) {
                        setUsdtPage(
                          usdtPagination.previousPage,
                        )
                      }
                    }}
                  >
                    ‹
                  </button>

                  {getPaginationPages(
                    usdtPage,
                    usdtPagination.totalPages,
                  ).map(
                    (item, index) => {

                      if (item === '...') {
                        return (
                          <span
                            key={`dots-${index}`}
                            className='market-page-dots'
                          >
                            ...
                          </span>
                        )
                      }

                      const isActive =
                        item === usdtPage

                      return (
                        <button
                          key={item}
                          type='button'
                          className={
                            `market-page-btn ` +
                            (
                              isActive
                                ? 'market-page-btn-active'
                                : ''
                            )
                          }
                          disabled={loader}
                          onClick={() => {
                            setUsdtPage(item)
                          }}
                        >
                          {item}
                        </button>
                      )
                    },
                  )}

                  <button
                    type='button'
                    className='market-page-btn'
                    disabled={
                      loader ||
                      !usdtPagination.hasNextPage
                    }
                    onClick={() => {
                      if (
                        usdtPagination.nextPage
                      ) {
                        setUsdtPage(
                          usdtPagination.nextPage,
                        )
                      }
                    }}
                  >
                    ›
                  </button>
                </div>
                <div className='market-page-limit'>
                  <span>
                    Show:
                  </span>

                  <select
                    value={usdtLimit}
                    onChange={
                      handleLimitChange
                    }
                    disabled={loader}
                  >
                    {USDT_LIMIT_OPTIONS.map(
                      (limit) => (
                        <option
                          key={limit}
                          value={limit}
                        >
                          {limit}
                        </option>
                      ),
                    )}
                  </select>
                </div>

              </div>
            )}

        </>
      )}

      {loader && (
        <div style={{ height: '55vh' }}>
          <LoaderUnitic width={80} />
        </div>
      )}

      {!loader &&
        !hasMarkets && (
          <div style={{ height: '55vh' }}>
            <div className='text-center mx-auto mt-5'>
              <img
                className='no-record-image'
                src='/assets/no-re.png'
                alt='no-record'
              />

              <br />

              <span className='text-center'>
                No Records Found
              </span>
            </div>
          </div>
        )}
    </div>
  )
}

export default UTI